module.exports = __webpack_public_path__ + "FixelDisplay-SemiBoldItalic-2c731772db2beed47a5adcec8a666684.woff2";